export const SliceNames = Object.freeze({
    CONTENT: 'content',
    DYNAMIC_RATES_TABLE: 'dynamic_rates_table',
    FAQ: 'faq',
    FAQ_WITH_TITLE: 'faq_with_title',
    FEATURED_ICONS: 'featured_icons',
    FEATURED_IMAGES: 'featured_images',
    HERO: 'hero',
    HERO_WITH_IMAGE: 'hero_with_image',
    HTML_FORM: 'html_form',
    INTERNAL_LINK_LIST: 'internal_link_list',
    RICH_TEXT_WITH_TITLE: 'rich_text_with_title',
    THREE_COLUMN_TABLE: 'three_column_table',
    TWO_COLUMN_TABLE: 'two_column_table',
    VIDEO: 'video',
    INFO_BANNER: 'info_banner',
    FIFTY_FIFTY: '50_50_split',
    TEXT_ME_THE_APP: 'text_me_the_app',
});
